import { QuadrantLabelText, TimeLine } from './atoms';
import { Quadrant, QuadrantOverlayProps } from './types';

const QuadrantOverlay = ({
  chartWidth,
  chartHeight,
  margin,
  timeCenterX,
  timeCenterY,
  chartAreaClipPathUrl,
  labelTextCoordinates: {
    leftQuadrantsLabelX,
    rightQuadrantsLabelX,
    topQuadrantsLabelY,
    bottomQuadrantsLabelY,
  },
  clipPathIds: {
    topRightQuadrantClipPath,
    bottomRightQuadrantClipPath,
    bottomLeftQuadrantClipPath,
    topLeftQuadrantClipPath,
  },
  labelTexts: {
    topLeftLabelText,
    topRightLabelText,
    bottomLeftLabelText,
    bottomRightLabelText,
  },
  selectedQuadrant,
}: QuadrantOverlayProps) => (
  <>
    <clipPath id={topRightQuadrantClipPath}>
      <rect
        x={timeCenterX}
        height={Math.max(0, timeCenterY)}
        width={Math.max(0, chartWidth - timeCenterX)}
      />
    </clipPath>
    <clipPath id={bottomRightQuadrantClipPath}>
      <rect
        x={timeCenterX}
        y={timeCenterY}
        height={Math.max(0, chartHeight - timeCenterY)}
        width={Math.max(0, chartWidth - timeCenterX)}
      />
    </clipPath>
    <clipPath id={bottomLeftQuadrantClipPath}>
      <rect
        y={timeCenterY}
        height={Math.max(0, chartHeight - timeCenterY)}
        width={Math.max(0, timeCenterX)}
      />
    </clipPath>
    <clipPath id={topLeftQuadrantClipPath}>
      <rect
        height={Math.max(0, timeCenterY)}
        width={Math.max(0, timeCenterX)}
      />
    </clipPath>
    <g
      transform={`translate(${margin.left} ${margin.top})`}
      clipPath={`url(#${chartAreaClipPathUrl})`}
    >
      {!selectedQuadrant && (
        <>
          <TimeLine x1="0" x2={chartWidth} y1={timeCenterY} y2={timeCenterY} />
          <TimeLine x1={timeCenterX} x2={timeCenterX} y1="0" y2={chartHeight} />
        </>
      )}

      <QuadrantLabelText
        x={leftQuadrantsLabelX}
        y={topQuadrantsLabelY}
        style={{ clipPath: `url(#${topLeftQuadrantClipPath})` }}
      >
        {!selectedQuadrant || selectedQuadrant === Quadrant.TOP_LEFT
          ? topLeftLabelText
          : null}
      </QuadrantLabelText>
      <QuadrantLabelText
        x={rightQuadrantsLabelX}
        y={topQuadrantsLabelY}
        style={{ clipPath: `url(#${topRightQuadrantClipPath})` }}
      >
        {!selectedQuadrant || selectedQuadrant === Quadrant.TOP_RIGHT
          ? topRightLabelText
          : null}
      </QuadrantLabelText>
      <QuadrantLabelText
        x={rightQuadrantsLabelX}
        y={bottomQuadrantsLabelY}
        style={{ clipPath: `url(#${bottomRightQuadrantClipPath})` }}
      >
        {!selectedQuadrant || selectedQuadrant === Quadrant.BOTTOM_RIGHT
          ? bottomRightLabelText
          : null}
      </QuadrantLabelText>
      <QuadrantLabelText
        x={leftQuadrantsLabelX}
        y={bottomQuadrantsLabelY}
        style={{ clipPath: `url(#${bottomLeftQuadrantClipPath})` }}
      >
        {!selectedQuadrant || selectedQuadrant === Quadrant.BOTTOM_LEFT
          ? bottomLeftLabelText
          : null}
      </QuadrantLabelText>
    </g>
  </>
);
export { QuadrantOverlay };
